// extracted by mini-css-extract-plugin
export var container = "_6g-0";
export var icon = "_6g-1";
export var text = "_6g-2";